import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {NavLink} from 'react-router-dom';

export default class Footer extends Component {

    render() {
        return (
            <footer>
                <div className="top-footer">
                    <div className="container">
                        <div className="top-footer-container">
                            <div>
                                <div className="title">
                                    <h6> Bizi Takip Edin </h6>
                                    <span> Sosyal medyada bizi takip edin.</span>
                                </div>

                                <div className="content">
                                    <ul className="social">
                                        <li>
                                            <a href="https://www.instagram.com/saydamalbum06/" target="_blank" rel="noopener">
                                                <i class="fa fa-instagram"></i>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div>
                                <div className="title">
                                    <h6> Abonelik </h6>
                                    <span> Bize abone olup, kampanyalardan ilk siz haberdar olun. </span>
                                </div>

                                <div className="content">
                                    <form className="subscriptions">
                                        <input type="email" placeholder="E-Posta Adresiniz"/>
                                        <RaisedButton
                                            id="subscritions-button"
                                            backgroundColor="#a4c639"
                                            icon={<i className="material-icons">add_box</i>}
                                        />
                                    </form>
                                </div>
                            </div>

                            <div>
                                <div className="title">
                                    <h6> Menü </h6>
                                </div>

                                <div className="content">
                                    <ul className="footer-menu">
                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}/`}> Anasayfa </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}/hakkimizda`}> Hakkımızda </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}/iletisim`}> İletişim </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}/saydamprofil`}> Saydam </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom-footer">
                    <div className="container">
                        <div className="bottom-footer-container">
                            <div className="contact">
                                <div className="contact-icon">
                                    <i className="material-icons">perm_phone_msg</i>
                                    <span> Bizimle iletişime geçin </span>
                                </div>
                                <a href="tel:+905424812344">
                                    <span> +90 542 481 23 44</span>
                                </a>
                                <a href="tel:+905058958208">
                                    <span> +90 505 895 82 08</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }


}


// WEBPACK FOOTER //
// ./src/footer.js